import React from 'react';

import Pagination from 'react-bootstrap/Pagination';

class Pages extends React.Component {

  render() {
    let pagesLink = [];
    if (this.props.current > 3) {
      pagesLink = [ ...pagesLink, <Pagination.First key="0" onClick={() => this.props.onPageChange(1)} />];
    }
    if(this.props.current > 4) {
      pagesLink = [ ...pagesLink, <Pagination.Ellipsis key="1" />];
    }
    if (this.props.current > 3) {
      pagesLink = [ ...pagesLink, <Pagination.Prev key="2" onClick={() => this.props.onPageChange(this.props.current - 1)} />];
    }
    if (this.props.current > 2) {
      pagesLink = [ ...pagesLink, <Pagination.Item key="3" onClick={() => this.props.onPageChange(this.props.current - 2)}>{this.props.current - 2}</Pagination.Item>];
    }
    if(this.props.current > 1) {
      pagesLink = [ ...pagesLink, <Pagination.Item key="4" onClick={() => this.props.onPageChange(this.props.current - 1)}>{this.props.current - 1}</Pagination.Item>];
    }
    pagesLink = [ ...pagesLink, <Pagination.Item key="5" active>{this.props.current}</Pagination.Item>];
    if(this.props.end - this.props.current > 0) {
      pagesLink = [ ...pagesLink, <Pagination.Item key="6" onClick={() => this.props.onPageChange(this.props.current + 1)}>{this.props.current + 1}</Pagination.Item>];
    }
    if(this.props.end - this.props.current > 1) {
      pagesLink = [ ...pagesLink, <Pagination.Item key="7" onClick={() => this.props.onPageChange(this.props.current + 2)}>{this.props.current + 2}</Pagination.Item>];
    }
    if(this.props.end - this.props.current > 2) {
      pagesLink = [ ...pagesLink, <Pagination.Next key="8" onClick={() => this.props.onPageChange(this.props.current + 1)}/>];
    }
    if(this.props.end - this.props.current > 3) {
      pagesLink = [ ...pagesLink, <Pagination.Ellipsis key="9" />];
    }
    if(this.props.end - this.props.current > 2) {
      pagesLink = [ ...pagesLink, <Pagination.Last key="10" onClick={() => this.props.onPageChange(this.props.end)}/>];
    } 

    return (
      <Pagination>
        {pagesLink}
      </Pagination>
    );
  }
}

export default Pages;
